<script setup lang="ts">
/**
 * /ats-friendly-resume-template — the template query ("ats friendly resume
 * template", "ats resume format", "what is an ats resume").
 *
 * Split with the neighbours so none competes for the same query:
 *   /templates                     every layout, and the format decision
 *   /ats-friendly-resume-template  what makes a layout safe for a parser  ← this page
 *   /blog/how-to-create-an-ats-friendly-resume-…  writing for the ATS (keywords,
 *                                  tailoring); Google treats that as a how-to,
 *                                  the template query as a download (checked
 *                                  2026-09-29, the two SERPs share one result)
 *
 * The page shows the text our Basic template actually hands a parser — output
 * of scripts/check-pdf-reading-order.cjs, the same check that guards every
 * template — rather than asserting "100% ATS-optimized".
 *
 * FAQPage only: a checklist is not one procedure, so no HowTo (see useJsonLd).
 */
const { t } = useI18n()
const { faqPageNode } = useJsonLd()

definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/ats-sablona-zivotopisu', de: '/ats-lebenslauf-vorlage', pl: '/szablon-cv-ats' } })

/** Answered in prose on the page, and mirrored into FAQPage structured data. */
const FAQ_IDS = ['what', 'pdf', 'columns', 'photo', 'canva', 'docs', 'score'] as const

const faqItems = computed(() =>
  FAQ_IDS.map(id => ({
    id,
    question: t(`atsTemplateGuide.faq.${id}.q`),
    answer: t(`atsTemplateGuide.faq.${id}.a`),
  })),
)

const extraNodes = computed(() => [
  faqPageNode('/ats-friendly-resume-template', faqItems.value),
])
</script>

<template>
  <MarketingFeaturePage
    seo-key="atsTemplate"
    path="/ats-friendly-resume-template"
    :breadcrumb-title="t('atsTemplateGuide.heading')"
    :extra-nodes="extraNodes"
  >
    <MarketingAtsTemplateGuide />

    <MarketingFaqSection
      :title="t('atsTemplateGuide.faq.title')"
      :items="faqItems"
      name="ats-template-faq"
    />
  </MarketingFeaturePage>
</template>
